import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

// 退货订单列表
export const findReturnList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/order/refundDetailList?` + params,
        method: 'GET'
    })
}

// 退货订单导出
export const exportReturnExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/order/refundDetail/downloadExcelRefundDetail?` + params,
        responseType: "blob",
        method: 'GET'
    })
}

// 确认退货
export const confirmReturn = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/order/partialRefundOrder`,
        method: 'PUT',
        data: data
    })
}

// 获取订单商品明细
export const getOrderGoods = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/order/goods/${id}`,
        method: 'GET'
    })
}
